var ads = {};
ads.lastAdTime = 0;
ads.wait = 2 * 60 * 1000; // minutes

ads.init = function () {
  window.SDK_OPTIONS = {
    gameId: "jqn9v76y49emaojekencs8ujdwyw3lym",
    onEvent: function (a) {
      switch (a.name) {
        case "SDK_GAME_PAUSE":
          // pause game logic / mute audio
          break;
        case "SDK_GAME_START":
          // advertisement done, resume game logic and unmute audio
          {
            ads.onVideoCompleted();
          }
          break;
        case "SDK_ERROR":
          {
            ads.onVideoNotAvailable();
          }
          break;
      }
    },
  };
  (function (a, b, c) {
    var d = a.getElementsByTagName(b)[0];
    a.getElementById(c) || ((a = a.createElement(b)), (a.id = c), (a.src = "https://api.gamemonetize.com/sdk.js"), d.parentNode.insertBefore(a, d));
  })(document, "script", "gamemonetize-sdk");
  ads.preloadRewardedAd();
};

ads.showAd = function () {
  if (window.sdk === undefined || window.sdk.showBanner === undefined) return;

  ads.currentAdd = "midgame";
  window.sdk.showBanner();
};

ads.showRewardedVideo = function (placement) {
  if (window.sdk === undefined || window.sdk.showBanner === undefined) return;

  if (!ads.preloaded) {
    setTimeout(gameScreen.openWarning, 750, "noAdsTitle", "noAdsText");
  }

  if (ads.getWaitingTime() === 0) {
    ads.videoIsActive = true;
    ads.currentAdd = "rewarded";
    window.sdk.showBanner();
  } else {
    gameLogic.rewardPlayer();
  }
};

ads.preloadRewardedAd = function () {
  ads.preloaded = true;
  return;
  if (window.sdk === undefined || window.sdk.preloadAd === undefined) {
    setTimeout(ads.preloadRewardedAd, 1000);
    return;
  }
  window.sdk
    .preloadAd("rewarded")
    .then((response) => {
      ads.preloaded = true;
    })
    .catch((error) => {
      ads.preloaded = false;
    });
};

ads.onVideoStarted = function () {
  ads.videoIsActive = true;
};

ads.onVideoCompleted = function () {
  ads.videoIsActive = false;
  ads.lastAdTime = Date.now();
  if (ads.currentAdd === "rewarded") {
    gameLogic.rewardPlayer();
    ads.preloadRewardedAd();
  }
};

ads.onVideoNotAvailable = function () {
  ads.videoIsActive = false;
  if (ads.currentAdd === "rewarded") {
    ads.preloaded = false;
    if (ads.adBlocker) {
      setTimeout(gameScreen.openWarning, 750, "adBlockerTitle", "adBlockerText");
    } else {
      setTimeout(gameScreen.openWarning, 750, "oopsTitle", "oopsText");
    }
  }
};

//waiting time
ads.getWaitingTime = function () {
  return Math.max(0, ads.wait + ads.lastAdTime - Date.now());
};

ads.happyTime = function (power) {
  if (window.sdk == undefined) return;
  //
};

ads.gameplayStop = function () {
  if (window.sdk == undefined) return;
  //
  //
};

ads.gameplayStart = function () {
  if (window.sdk == undefined) return;
  //
};

ads.gameLoadingStart = function () {
  if (window.sdk == undefined) return;
  //
};

ads.gameLoadingFinished = function () {
  if (window.sdk === undefined) return;
  //
};

ads.gameLoadingProgress = function (progress) {
  if (window.sdk == undefined) return;
  //
};

ads.init();

//sitelock
